import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";
import _ from 'lodash';

class GoalsSearch extends Component {
	render() {
		const { goals, modalities, entities } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<div className="select is-small">
					<select name="type" id="type" value={goals.filters.type} onChange={this._typeChange}>
						<option value="">--- Tipo de meta ---</option>
						<option value="RI">Rumbo a la Igualdad</option>
						<option value="MT">Meta Tipo</option>
						<option value="MI">Meta IMEF</option>
					</select>
				</div>
			</div>

			<div className="control">
				<div className={`select is-small${modalities.isFetching ? ' is-loading':''}`} >
					<select name="modality_id" id="modality_id" value={goals.filters.modality_id} onChange={this._modalityChange}>
						<option value="">--- Modalidad ---</option>
						{_.map(modalities.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.name}</option>
							)
						})}
					</select>
				</div>
			</div>

			{goals.filters.modality_id === '1' ?
			<div className="control">
				<div className={`select is-small${entities.isFetching ? ' is-loading':''}`} >
					<select name="state_id" id="state_id" value={goals.filters.state_id} onChange={this._entityChange}>
						<option value="">--- Entidad ---</option>
						{_.map(entities.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.name}</option>
							)
						})}
					</select>
				</div>
			</div>:''}

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={goals.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._typeChange = this._typeChange.bind(this);
		this._modalityChange = this._modalityChange.bind(this);
		this._entityChange = this._entityChange.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	componentWillMount(){
		this.props.fetchEntities();
	}

	_submitSearch() {
		const {goals} = this.props;
		this.props.goalsShow(1,goals.filters);
	}

	_typeChange(event){
		this.props.change('goals.filters.type',event.target.value);
	}

	_modalityChange(event){
		this.props.change('goals.filters.modality_id',event.target.value);
		this.props.change('goals.filters.state_id','');
	}

	_entityChange(event){
		this.props.change('goals.filters.state_id',event.target.value);
	}

	_searchChange(event){
		this.props.change('goals.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('goals.filters');
		this.props.goalsShow(1);
	}
}

export default SecureLayout(GoalsSearch);



// WEBPACK FOOTER //
// ./src/elements/goals/widget/goals_search.jsx